import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ROUTING_CONFIG } from '@uplift/constants';
import { L10nHTML, useL10n, useUpBreakpoint } from '@uplift/hooks';
import { TitleOfBlock, Alert } from '@uplift/ui-v2';
import { Link as RouterLink } from 'react-router-dom';

export type UnsubmittedSessionsHeaderProps = {
  unsubmittedSessionsLength: number;
  hasExpiredSession: boolean;
};

export const useStyles = makeStyles()((theme) => ({
  breadcrumb: {
    color: theme.palette.text.primary,
    '&:visited': {
      color: theme.palette.text.primary
    }
  },
  nextBreadcrumb: {
    color: theme.palette.text.disabled,
  },
  title: {
    color: theme.palette.darkSlate.main,
    marginBottom: 0,
    fontSize: '36px',
    [theme.breakpoints.up('xs')]: {
      fontSize: '34px'
    }
  },
  alertTitle: {
    fontWeight: 700
  }
}));

export const UnsubmittedSessionsHeader: React.VFC<UnsubmittedSessionsHeaderProps> = ({ unsubmittedSessionsLength, hasExpiredSession }) => {
  const l10n = useL10n();
  const isSmUp = useUpBreakpoint('sm');
  const { classes } = useStyles();

  return (
    <Box mb={3}>
      <Box mb={{ xs: 0.5, sm: 1 }}>
        <TitleOfBlock text={l10n.pages.unsubmittedSessions} className={classes.title} />
      </Box>
      {isSmUp ? (
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            component={RouterLink}
            to={ROUTING_CONFIG.home}
            className={classes.breadcrumb}
          >
            {l10n.pages.main}
          </Link>
          <Typography className={classes.nextBreadcrumb}>
            {l10n.pages.unsubmittedSessions}
          </Typography>
        </Breadcrumbs>
      ) : (
        <Box py={0.25}>
          <L10nHTML color="textSecondary">
            {l10n.unsubmittedSessions.sessionsToSubmitOrCancel(unsubmittedSessionsLength)}
          </L10nHTML>
        </Box>
      )}

      {hasExpiredSession && (
        <Box mt={3}>
          <Alert
            title={l10n.unattendedSession.title}
            color="warning"
            severity="warning"
            classes={{
              title: classes.alertTitle
            }}
          >
            <L10nHTML variant="body2" color="textPrimary">
              {l10n.unattendedSession.desc}
            </L10nHTML>
          </Alert>
        </Box>
      )}
    </Box>
  );
};
